export default __webpack_public_path__ + "static/media/DetectiveRed.b16efbd0.png";